export default __webpack_public_path__ + "static/media/undraw_design_community_rcft.d461c968.svg";